
export type GetCourseDraftCountParams = {
/**
 * 강사 ID (생략 시 현재 사용자)
 */
instructorId?: string;
};
